import {
    BaseLayer,
    BaseLayerFactory_27700,
    BaseLayerFactory_3857,
    BaseLayerType
} from "esdm-map";

import { IBaseLayer } from "esdm-map/dist/baselayers/interfaces/IBaseLayer";
import TileLayer from "ol/layer/Tile";
import TileGrid from "ol/tilegrid/TileGrid";
import TileWMS from 'ol/source/TileWMS';

import * as olProj from 'ol/proj';
import proj4 from "proj4";
import { register } from 'ol/proj/proj4';
import Projection from "ol/proj/Projection";
import XYZ from 'ol/source/XYZ';
import OSM from 'ol/source/OSM';

export const HighlandBaseLayerTypes = {
    ...BaseLayerType,
    HighlandOS: 999
};

export class HighlandBaseMapping_27700 extends BaseLayerFactory_27700 {

    private _baseLayerFactory_3857: BaseLayerFactory_3857;

    public constructor() {
        super();

        this._baseLayerFactory_3857 = new BaseLayerFactory_3857();
     
        proj4.defs('EPSG:27700', '+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 ' +
            '+x_0=400000 +y_0=-100000 +ellps=airy ' +
            '+towgs84=446.448,-125.157,542.06,0.15,0.247,0.842,-20.489 ' +
            '+units=m +no_defs');
        register(proj4);
        var proj27700 = olProj.get('EPSG:27700');
        proj27700.setExtent([0, 0, 700000, 1300000]);
    }
    

    public GetBaseLayerByType(baseLayerType: BaseLayerType, bingApiKey: string, esdmOsmApiKey:string): IBaseLayer {
        if (baseLayerType === HighlandBaseLayerTypes.HighlandOS) {
            return this.GetHighlandOS();
        }     

        if (baseLayerType == HighlandBaseLayerTypes.BingAerial) {
            return this._baseLayerFactory_3857.GetBaseLayerByType(baseLayerType, bingApiKey, esdmOsmApiKey);
        }              

        return super.GetBaseLayerByType(baseLayerType, bingApiKey, esdmOsmApiKey);
    }

    private GetHighlandOS(): IBaseLayer {
        let lyr = new TileLayer({
            visible: false,
            source: new TileWMS({
                //urls: ["/api/OgcService/HighlandBaseMapping"],
                urls: ["https://map.publicsectormapping.gov.scot/osmao-highl-c0006-99302/service"],
                params: {
                    LAYERS: 'viaEuropa_m0105',
                    //TILED: 'true',
                    FORMAT: 'image/png',
                    SRS: 'EPSG:27700'
                },
                projection: "EPSG:27700",                  
                attributions: `<div>© Crown Copyright and database rights ${new Date().getFullYear()} Ordnance Survey.<br />HER data &copy; Highland Council</div>`,
                crossOrigin:'anonymous'
            })
        });
        return new BaseLayer("highlandOS", "Ordnance Survey", lyr);
    }

}